/**
 * Files redesign pilot gate — TEMPORARY.
 *
 * Decides whether a signed-in user sees the redesigned Project Hub Files tab
 * (Deliverables / Submittals / RFQs / Project folders, structures, split tracks,
 * Client view) or is held on the classic single-page layout. Driven by one
 * Firestore doc, `settings/files_redesign`, edited from Settings → Operations →
 * "Files redesign pilot". Fails closed: no doc / read error = classic.
 *
 * Built on the shared {@link createPilotFlag} helper (`pilotFlagAccess.ts`); the
 * names below are kept so the consumers / tests read as before.
 *
 * ─────────────────────────────────────────────────────────────────────────────
 * REMOVAL CHECKLIST — do this in the release after "Enable for everyone" ships:
 *
 *   1. src/components/pm/ProjectFiles.tsx
 *        - delete the `useFilesRedesignAccess()` call and the `redesign` const
 *        - set `const classicView = classicViewPref;` (drop `redesign.*` terms)
 *        - un-hide the "Classic files view" checkbox (remove `redesign.enabled &&`)
 *   2. src/components/settings/SettingsHubSection.tsx
 *        - remove the `<FilesRedesignPilotCard … />` mount (keep the
 *          "Reset Files walkthrough" button it renders — move it back onto
 *          DesignerStandardsSettingsCard's footer or wherever it lives then)
 *   3. Delete files:
 *        - src/utils/filesRedesignAccess.ts (this file)
 *        - src/utils/filesRedesignAccess.test.ts
 *        - src/components/settings/FilesRedesignPilotCard.tsx (+ .css)
 *   4. firestore.rules — drop the `match /settings/files_redesign { … }` block.
 *   5. Firestore — delete the `settings/files_redesign` document.
 *   6. src/components/release/ReleaseAudiencePicker.tsx — the optional
 *      `includeTestUsers` prop can stay (harmless) or go.
 * ─────────────────────────────────────────────────────────────────────────────
 */

import {
  createPilotFlag,
  EMPTY_PILOT_FLAG,
  isPilotFlagEnabled,
  listPilotCandidates,
  parsePilotFlag,
  PILOT_PEOPLE_OPTIONS,
  type PilotFlag,
  type PilotFlagAccess,
  type SavePilotFlagPatch,
} from './pilotFlagAccess';

export const FILES_REDESIGN_DOC_ID = 'files_redesign';

export type FilesRedesignFlag = PilotFlag;
export const EMPTY_FILES_REDESIGN_FLAG: FilesRedesignFlag = EMPTY_PILOT_FLAG;
export const parseFilesRedesignFlag = parsePilotFlag;
export const isFilesRedesignEnabled = isPilotFlagEnabled;
export const FILES_PILOT_PEOPLE_OPTIONS = PILOT_PEOPLE_OPTIONS;
export const listFilesPilotCandidates = listPilotCandidates;
export type SaveFilesRedesignPatch = SavePilotFlagPatch;
export type FilesRedesignAccess = PilotFlagAccess;

export const filesRedesignFlag = createPilotFlag(FILES_REDESIGN_DOC_ID);

export const subscribeFilesRedesignAccess = filesRedesignFlag.subscribe;
export const saveFilesRedesignAccess = filesRedesignFlag.save;
/** Live gate for the signed-in user. One subscription per mounted consumer. */
export const useFilesRedesignAccess = filesRedesignFlag.useAccess;
